import React, { useState, useRef, useEffect } from 'react'
import { Card, Row, Col } from 'antd'
import { LoginOutlined, SnippetsOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'

import Layout from '../components/layout/Layout'

function Logs() {
  const navigate = useNavigate()
  const auth = useSelector((state) => state.auth)
  const [isLocal, setIsLocal] = useState(process.env.REACT_APP_ENVIRONMENT === 'local')
  const [isDeveloper, setIsDeveloper] = useState(auth.user.email == 'kamal@kamal.com' || auth.user.email == 'andalibkibria@yahoo.com.au')

  const actions = [
    {
      title: 'Login logs',
      icon: <LoginOutlined style={{ fontSize: 36, color: 'black' }} />,
      path: '/logs/loginLogoutLogs',
      description: 'See the login and logout button click timestamps by users.',
      production: true, // Show both at local & production place
    },
    {
      title: 'Leaderboard Visits',
      icon: <SnippetsOutlined style={{ fontSize: 36, color: '#8838cf' }} />,
      path: '/logs/leaderboardVisits',
      description: 'See the number of visits. View cached or non cached visits.',
      production: false, // Don't show at production
    },
    {
      title: 'Global Search',
      icon: <SnippetsOutlined style={{ fontSize: 36, color: '#cf38b8' }} />,
      path: '/logs/globalSearchLogs',
      description: 'See the queries.',
      production: false, // Don't show at production
    },
    {
      title: 'Feed Visits',
      icon: <SnippetsOutlined style={{ fontSize: 36, color: '#384fcf' }} />,
      path: '/logs/feedVisits',
      description: 'See the number of times the user visited the feed.',
      production: false, // Don't show at production
    },
    {
      title: 'Like Posts Logs',
      icon: <SnippetsOutlined style={{ fontSize: 36, color: '#384fcf' }} />,
      path: '/logs/likePostLogs',
      description: '...',
      production: false, // Don't show at production
    },
  ]

  const filteredActions = actions.filter((item) => {
    // In production: only allow production=true
    if (!isDeveloper) {
      return item.production === true
    }

    // In isDeveloper: allow everything
    return true
  })

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h2>Logs</h2>

        <Row gutter={[24, 24]}>
          {filteredActions.map((item, index) => (
            <Col xs={24} sm={12} md={8} lg={6} key={index}>
              <Card
                hoverable
                onClick={() => navigate(item.path)}
                style={{
                  borderRadius: 12,
                  textAlign: 'center',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.08)',
                  transition: 'transform 0.2s',
                  minHeight: 200,
                }}
                bodyStyle={{ padding: '24px 16px' }}
              >
                <div style={{ marginBottom: 12 }}>{item.icon}</div>
                <h3 style={{ marginBottom: 8 }}>{item.title}</h3>
                <p style={{ color: 'rgba(0,0,0,0.45)' }}>{item.description}</p>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </Layout>
  )
}

export default Logs
